import { useFormData } from '@components/common/jsonSchemaForm/formContext';
import { JSONSchema } from '@components/common/jsonSchemaForm/jsonSchemaForm';
import DateWidget from '@components/common/jsonSchemaForm/widgets/dateWidget';
import moment from 'moment';
import React from 'react';
import { WidgetProps } from '@rjsf/core';
/* 
    UI schema for singer-google-adwords source
    We need to use query builder for custom queries
*/
export const singerGoogleAdsUISchema = (schemaProperties: JSONSchema['properties']) =>
  Object.keys(schemaProperties!).reduce((uiSchema, propName) => {
    if (propName === 'custom_queries') {
      uiSchema[propName] = {
        items: {
          query: {
            'ui:widget': 'GAQueryBuilder',
          },
        },
      };
    }
    return uiSchema;
  }, {} as Record<string, Record<string, unknown>>);

/* 
    UI schema for singer-recurly source
    We need to make sure that when begin_time exists,
    dates before begin_time are disabled for end_time field
*/
export const singerRecurlyUISchema = (schemaProperties: JSONSchema['properties']) =>
  Object.keys(schemaProperties!).reduce((uiSchema, propName) => {
    if (propName === 'end_time') {
      uiSchema[propName] = {
        'ui:widget': (props: WidgetProps) => {
          const { formData } = useFormData();
          if (
            formData.begin_time &&
            formData.end_time &&
            moment(formData.begin_time as string).isAfter(formData.end_time as string)
          ) {
            // reset end_time if begin_time change after end_time is set
            props.onChange(undefined);
          }
          return (
            <DateWidget
              {...props}
              disabledDate={(currentDate) => {
                if (formData.begin_time) {
                  return currentDate.isBefore(moment(formData.begin_time as string).add(1, 'day'));
                }
                return false;
              }}
            />
          );
        },
      };
    }
    return uiSchema;
  }, {} as Record<string, Record<string, unknown>>);
